export const defaultHeaderImg = require('@components/assets/icons/default-header.webp');
export const closeIcon = require('@components/assets/icons/clear.webp');
export const searchIcon = require('@components/assets/icons/proxy/search-icon.webp');
